var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav',[_c('ul',{staticClass:"side-nav-bar"},[_c('profile'),_vm._v(" "),_c('side-navigation-items',{on:{"hideMobileNavBar":_vm.hideMobileNavBar,"showLogoutMenu":_vm.showLogoutMenu}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }